import { db } from './db/db';
import { useLiveQuery } from 'dexie-react-hooks';
import { ToastContainer } from 'react-toastify';
import ProviderWrapper from './components/ProviderWrapper/index';
import AppRoutes from './routes';
import GlobalStyle from './assets/styles/styles';
import { useSelector } from 'react-redux';
import { RootState } from './store';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler
} from 'chart.js';
import { sendHeartbeat } from './services';
import { useCallback, useEffect } from 'react';
import { ScreenProvider } from './context/ScreenContext';
import { ZendeskMessagingProvider } from './integrations/ZendeskMessagingProvider';
import { terminateIokSession } from './integrations/iokSessionLifecycle';
import { PwaInstallProvider } from './context/PwaInstallContext';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const GlobalStyleWrapper = () => {
  const showScroll = useSelector((state: RootState) => state.scroll.showScroll);
  return <GlobalStyle showScroll={showScroll} />;
};

const App = () => {
  const userDb = useLiveQuery(() => db.user.toArray());
  const companyDb = useLiveQuery(() => db.company.toArray());
  const userConfigsDb = useLiveQuery(() => db.userConfigs.toArray());
  const cookbookDb = useLiveQuery(() => db.cookbook.toArray());
  const zendeskUser = userDb === undefined ? undefined : userDb[0] ?? null;
  const accessToken = zendeskUser?.accessToken;
  const handleInvalidIokSession = useCallback(
    () => terminateIokSession({ reason: 'expired', publicPath: '/' }),
    []
  );

  useEffect(() => {
    if (!accessToken) {
      return;
    }

    sendHeartbeat(accessToken)

    const interval = setInterval(
      () => sendHeartbeat(accessToken),
      180000
    );

    return () => clearInterval(interval);
  }, [accessToken]);

  return (
    <ProviderWrapper userConfigs={userConfigsDb}>
      <GlobalStyleWrapper />
      <ZendeskMessagingProvider
        user={zendeskUser}
        language={userConfigsDb?.[0]?.language}
        onInvalidIokSession={handleInvalidIokSession}
      >
        <ScreenProvider>
          <PwaInstallProvider>
            <AppRoutes
              user={userDb}
              userConfigs={userConfigsDb}
              company={companyDb}
              cookbook={cookbookDb}
            />
          </PwaInstallProvider>
          <ToastContainer
            position='top-center'
            hideProgressBar
            closeButton={false}
          />
        </ScreenProvider>
      </ZendeskMessagingProvider>
    </ProviderWrapper>
  );
};
export default App;
